export const IS_DEVELOPMENT = process.env.NODE_ENV !== 'production'
